module.exports = __webpack_public_path__ + "img/heart8.29e950f6.png";